export class CreditDeniedDecisionDto {
  type: string;
}

export const DENIED_LEQ_ANSWERS = 'LEQ_ANSWERS';
export const DENIED_CREDIT_SCORE = 'CREDIT_SCORE_BISNODE';
export const DENIED_AMOUNT_TOO_HIGH = 'MONTHLY_AMOUNT_TOO_HIGH';
export const DENIED_UNKNOWN_REASON = 'UNKNOWN_REJECTION_REASON'
export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';